import { useEffect, useState } from 'react';

const SELECTOR = '.paywallax-ii-selector';

/**
 * Reserves scroll space equal to the fixed-position PaywallaxMarkII container
 * so the footer remains fully visible above the paywall when scrolled to the bottom.
 */
export const PaywallaxSpacer = () => {
  const [height, setHeight] = useState(0);

  useEffect(() => {
    const el = document.querySelector(SELECTOR);
    if (!el) {
      return;
    }

    const observer = new ResizeObserver((entries) => {
      for (const entry of entries) {
        setHeight(entry.contentRect.height);
      }
    });

    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  if (height <= 0) {
    return null;
  }

  return <div style={{ height }} />;
};
